import { ApiResponse, PaginationQuery, PaginationResponse } from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

export interface AdPlayRecordMedia {
  advertisement_media_id?: number
  file_uuid?: string
  media_order?: number
  play_duration_ms?: number | null
  is_active?: boolean
}

export interface AdPlayRecord {
  ad_play_record_id: number
  ad_id: number
  broadcast_device_id: number
  played_at: string
  created_at: string
  is_active: boolean
  broadcast_device: {
    broadcast_device_id: number
    name: string
  }
  advertisement: {
    advertisement_id: number
    title: string
    description: string
    supplier: {
      supplier_id: number
      supplier_name: string
    }
    media: AdPlayRecordMedia[]
  }
}

interface UseAdplayByBroadcastParams extends PaginationQuery {
  broadcastDeviceId: number
  startDate?: string
  endDate?: string
  adId?: number
  supplierId?: number
}

export function useAdplayByBroadcast({
  broadcastDeviceId,
  startDate,
  endDate,
  adId,
  supplierId,
  page = 1,
  pageSize = 10,
}: UseAdplayByBroadcastParams) {
  const { token } = useAuth()

  // Build query parameters
  const queryParams = new URLSearchParams({
    page: page.toString(),
    pageSize: pageSize.toString(),
  })

  if (startDate) queryParams.append('startDate', startDate)
  if (endDate) queryParams.append('endDate', endDate)
  if (adId) queryParams.append('adId', adId.toString())
  if (supplierId) queryParams.append('supplierId', supplierId.toString())

  const { data, error, mutate } = useGet<ApiResponse<PaginationResponse<AdPlayRecord>>>(
    token
      ? `/api/ad-play/records/by-broadcast-device/${broadcastDeviceId}?${queryParams.toString()}`
      : null,
    undefined,
    token ?? '',
  )

  return {
    records: data?.data?.items || [],
    pagination: data?.data
      ? {
          page: data.data.page,
          pageSize: data.data.pageSize,
          total: data.data.total,
          totalPages: data.data.totalPages,
        }
      : undefined,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
